import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=4421755a"
import script from "./ChangeDetail.vue?vue&type=script&lang=js"
export * from "./ChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetail.vue?vue&type=style&index=0&id=4421755a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports